import React from "react";
import { useTranslation } from "react-i18next";
import Picture from "../asset/picture.jpg";
import useLangPrefix from "../hooks/useLangPrefix";
import useRevealSection from "../hooks/useRevealSection";

const About: React.FC = () => {
  const { t } = useTranslation();
  const prefix = useLangPrefix();
  const sectionRef = useRevealSection<HTMLElement>();

  return (
    <section className="about" id="about" ref={sectionRef}>
      <h2 className="heading reveal">
        {t("about.headingPre")} <span>{t("about.headingSpan")}</span>
      </h2>

      <div className="about-img reveal reveal-left">
        <img src={Picture} alt="" />
        <span className="circle-spin"></span>
      </div>

      <div className="about-content reveal reveal-right reveal-d1">
        <h3>{t("about.role")}</h3>
        <p>{t("about.bio")}</p>
        <br />
        <h3>{t("about.whatIDoHeading")}</h3>
        <p>
          {t("about.whatIDoPre")}
          <a href="https://promptdoo.com" target="_blank" rel="noreferrer">
            promptdoo.com
          </a>
          {t("about.whatIDoPost")}
        </p>
      </div>

      <div className="btn-box btns btn-box-wide reveal reveal-d2">
        <a href={`${prefix}/#projects`} className="btn btn-wide">
          {t("about.cta")}
        </a>
      </div>
    </section>
  );
};

export default About;
